/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 18.07.2016.
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import _find from 'lodash/find';
import _findIndex from 'lodash/findIndex';

import {Guid} from '../../utils';
import {OpenMessage, CloseMessage} from '../../actions/common/actions-common';

import Message from '../../components/ModalWindow';

//this.props.OpenMessage({
//  type: 'common'  ,
//  title: 'Title for common window 1',
//  body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris. Fusce' +
//  ' nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur sodales ligula in libero. Sed dignissim lacinia nunc. Curabitur tortor.',
//  actions: [
//    {
//      title: 'yes',
//      func: () => {
//        console.log("YES!");
//      }
//    },
//    {
//      title: 'no',
//      func: () => {
//        console.log("NO!");
//      }
//    }
//  ]
//});

class ModalWindow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      messages: []
    };

    this._bindedOnKeyDown = this.onKeyDown.bind(this);
  }

  componentDidMount() {
    window.addEventListener('keydown', this._bindedOnKeyDown);

    if (this.props.message) {

      this.setState({
        messages: this.props.messages.map((message, index, arr) => {
          if (!message.id) message.id = Guid();

          message.isShown = index === arr.length - 1;

          return message;
        })
      });
    }
  }

  componentWillMount() {
    window.removeEventListener('keydown', this._bindedOnKeyDown);
  }

  componentWillReceiveProps(newProps) {
    let state = {
      isOpen: !!newProps.messages.length,
      length: newProps.messages.length,
      messages: newProps.messages.map((message, index, arr) => {
        if (!message.id) message.id = Guid();

        message.isShown = index === arr.length - 1;

        return message;
      })
    };

    this.setState(state);
  }

  onKeyDown(event) {
    let key = event.which;

    if (this.state.isOpen && key === 27) {
      if (event.preventDefault) event.preventDefault();
      if (event.stopPropagation) event.stopPropagation();

      let current = _find(this.state.messages, {isShown: true});

      if (current && !current.blocked) {
        current.onClose && current.onClose();
        this.onClose(current.id);
      }

      return false;

    }

    if (this.state.isOpen && key === 37) {
      if (event.preventDefault) event.preventDefault();
      if (event.stopPropagation) event.stopPropagation();

      let currentIndex = _findIndex(this.state.messages, {isShown: true});

      if (currentIndex !== -1 && this.state.messages[currentIndex - 1]) {

        this.setState({
          messages: this.props.messages.map((message, index) => {
            message.isShown = index === currentIndex - 1;

            return message;
          })
        });
      }

      return false;

    }

  if (this.state.isOpen && key === 39) {
      if (event.preventDefault) event.preventDefault();
      if (event.stopPropagation) event.stopPropagation();

      let currentIndex = _findIndex(this.state.messages, {isShown: true});

      if (currentIndex !== -1 && this.state.messages[currentIndex + 1]) {

        this.setState({
          messages: this.props.messages.map((message, index) => {
            message.isShown = index === currentIndex + 1;

            return message;
          })
        });
      }

      return false;

    }

  }

  selectMessage(indexx) {
    this.setState({
      messages: this.props.messages.map((message, index) => {
        message.isShown = index === indexx;

        return message;
      })
    });
  }

  onClose(message_id) {

    this.props.CloseMessage(message_id);
  }

  _renderMessages() {

    return this.state.messages.map((message) => {

      return <Message
        key={'message_' + message.id}
        message={message}
        isShown={message.isShown}
        onClose={this.onClose.bind(this, message.id)} />;
    });
  }

  _renderNavigation() {

    return (
      <div className="popup-navigation">
        {this.state.messages.length > 1 && this.state.messages.map((message, index) => {
          if (message.isShown) {
            return (<i key={'item_' + index} className="ic ic-14px ic-circle pointer"></i>);
          } else {
            return (<i key={'item_' + index} className="ic ic-11px ic-circle-outline pointer" onClick={this.selectMessage.bind(this, index)}></i>);
          }
        })}
      </div>);
  }

  render() {

    if (this.state.isOpen) {

      return (
        <div className="popup-confirm">
          {this._renderNavigation()}
          <div className="popup-block">
            {this._renderMessages()}
          </div>
        </div>
      );
    } else {

      return null;
    }
  }
}

const mapStateToProps = ({common: {messages}}) => {

  return {messages};
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({OpenMessage, CloseMessage}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalWindow);



// WEBPACK FOOTER //
// ./src/containers/ModalWindow/modal-window.js